import $ from "jquery";
import { endsWith } from "./typescript/Vgr.Util";

$.widget("customer.organizationQueryCompletion", {
  options: {
    source: "",
    header: "",
  },

  // Constructor
  _create: function () {
    this._initQueryCompletion();
  },
  _destroy: function () {},
  _initQueryCompletion: function () {
    let searchField = this.element;
    if (searchField.length <= 0) {
      return;
    }

    let resultContainer = $("#autocomplete-result");
    let searchButton = $("#SearchButton");
    let forvaltning = searchField.data("organizationname");
    let searchQuery = $`forvaltning=${encodeURIComponent(forvaltning)}&q=`;
    let endpoint = "OrganizationQueryCompletion";

    if (this.options.source === "episerver") {
      endpoint = "ProjectSearchQueryCompletion";
    }

    let urlPath = "/api/querycompletions/" + endpoint;

    this._addCloseResultContainerListenerOs(
      searchField,
      searchButton,
      resultContainer
    );

    let scope = "";
    let $scope = $("#SearchScope");
    if ($scope.length > 0) {
      scope = $scope.data("scope");
    }

    let self = this;
    searchField.autocomplete({
      minLength: 1,
      delay: 300,
      source: function (request) {
        $.ajax({
          dataType: "json",
          url: urlPath,
          type: "Get",
          data: {
            source: self.options.source,
            scope: scope,
            searchQuery: searchQuery.replace("q=", "q=" + request.term),
          },
          success: function (data) {
            if (data === "") return;
            if (data.suggestions.length === 0) {
              resultContainer.addClass("hidden");
              return;
            }
            resultContainer.html("");
            resultContainer.css("width", searchField.css("width"));
            resultContainer.removeClass("hidden");

            self._addSearchQueries(data.suggestions, resultContainer);
          },
        });
      },
    });
  },
  _addSearchQueries: function (queries, container) {
    let ulList = $(container)
      .append("<ul id='searchquery-list' ></ul>")
      .find("#searchquery-list");
    let $header = $("<LH>", {
      html: "<h2>" + this.options.header + "<h2>",
    }).appendTo(ulList);
    $header.addClass("autocomplete-resultheader");
    if (queries.length < 1) return;
    let self = this;
    $.each(queries, function (i) {
      let url = "";
      if (self.options.source == "episerver") {
        // If the source is a webpage then the the suggestion is a link to an page
        url = queries[i].label;
      } else {
        //Remove previous q-parameter and add it again with query completion value
        url =
          $("#FullQueryCompletionResultString")
            .val()
            .replace(/&?q=([^&]$|[^&]*)/i, "") +
          "&q=" +
          queries[i].label;
      }

      let li = $("<li/>").appendTo(ulList);
      let h3 = $("<h3>").appendTo(li);
      $("<a>", {
        html: queries[i].label_hl,
        href: url,
      }).appendTo(h3);
    });
  },
  _addCloseResultContainerListenerOs: function (
    searchField,
    searchButton,
    resultContainer
  ) {
    this._closeResultContainerMousedownOs(resultContainer);
    this._closeResultContainerFocusinOs(
      searchField,
      searchButton,
      resultContainer
    );
    this._closeResultContainerEscOs(resultContainer);
  },
  _closeResultContainerMousedownOs: function (resultContainer) {
    $("body").mousedown(function (e) {
      if (
        e.target.offsetParent == null ||
        e.target.offsetParent.id !== resultContainer[0].id
      ) {
        resultContainer.addClass("hidden");
      }
    });
  },
  _closeResultContainerFocusinOs: function (
    searchField,
    searchButton,
    resultContainer
  ) {
    $("body").focusin(function (e) {
      let focused = document.activeElement.id;
      // offsetParent is undefiend in some versions of IE 11
      if (e.target.offsetParent) {
        if (
          focused !== searchField[0].id &&
          focused !== searchButton[0].id &&
          e.target.offsetParent.id !== resultContainer[0].id
        ) {
          resultContainer.addClass("hidden");
        }
      }
    });
  },
  _closeResultContainerEscOs: function (resultContainer) {
    $(document).on("keyup", function (evt) {
      if (evt.keyCode == 27) {
        resultContainer.addClass("hidden");
      }
    });
  },
});
